import React from 'react'
//import Gallery from '../components/Gallery'

import LightGallery from 'lightgallery/react';

// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';

// If you want you can use SCSS instead of css
import 'lightgallery/scss/lightgallery.scss';
import 'lightgallery/scss/lg-zoom.scss';

// import plugins if you need
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

function GalleryPage() {
    const onInit = () => {
        console.log('lightGallery has been initialized');
    };
    return (
        <div className="App">
            <LightGallery
                onInit={onInit}
                speed={500}
                plugins={[lgThumbnail, lgZoom]}
            >
                <a href="/assets/4k_1-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_1-min.jpg" />
                </a>
                <a href="/assets/4k_2-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_2-min.jpg" />
                </a>
                <a href="/assets/4k_3-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_3-min.jpg" />
                </a>
                <a href="/assets/4k_4-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_4-min.jpg" />
                </a>
                {/* <a href="/assets/4k_5-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_5-min.jpg" />
                </a> */}
                <a href="/assets/4k_6-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_6-min.jpg" />
                </a>
                <a href="/assets/4k_7-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_7-min.jpg" />
                </a>
                <a href="/assets/4k_8-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_8-min.jpg" />
                </a>
                <a href="/assets/4k_9-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_9-min.jpg" />
                </a>
                <a href="/assets/4k_10-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_10-min.jpg" />
                </a>
                <a href="/assets/4k_11-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_11-min.jpg" />
                </a>
                <a href="/assets/4k_12-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_12-min.jpg" />
                </a>
                <a href="/assets/4k_13-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_13-min.jpg" />
                </a>
                <a href="/assets/4k_14-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_14-min.jpg" />
                </a>
                <a href="/assets/4k_15-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_15-min.jpg" />
                </a>
                <a href="/assets/4k_16-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_16-min.jpg" />
                </a>
                <a href="/assets/4k_17-min.jpg">
                    <img alt="img1" src="/assets/tnd_4k_17-min.jpg" />
                </a>
            </LightGallery>
        </div>
    );
}

function ImageGallery() {
    return (
        <div className='image-gallery-container'>
            <h1 className="page-title">Blackbird 66 Mk.1 Gallery</h1>
            <GalleryPage />
        </div>
    )
}

export default ImageGallery
